export default __webpack_public_path__ + "static/media/nomock.22d32fe6.png";